import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import PatientState, {IPatient, IPatientType, PatientList} from './states'
import _ from 'lodash'
import { State } from '@/store/store'
import axios from 'axios'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'

const actions: ActionTree<PatientState, State> = {
  async getPatientList(
    { commit, dispatch, state }: ActionContext<PatientState, State>,
    options: object,
  ): Promise<void> {
    await HttpRequestServiceWithToken
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'patient', options, (res: PatientList) => {
        commit(mutationType.GET_LISTS, res)
      })
  },
  async getPatientById(
    { commit, dispatch, state }: ActionContext<PatientState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
    .getByLevel(process.env.VUE_APP_API_URL + '/v1', `patient/${id}`, options, (res: IPatient) => {
      commit(mutationType.GET_BY_ID, res)
    })
  },
  async postPatient(
    { commit, dispatch, state }: ActionContext<PatientState, State>,
    options: object,
  ): Promise<void> {
    return await HttpRequestServiceWithToken
      .postByLevel(process.env.VUE_APP_API_URL + '/v1', 'patient', options, (res: IPatient) => {
        return res
        // commit(mutationType.CREATE, res)
      })
  },
  async putPatient(
    { commit, dispatch, state }: ActionContext<PatientState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
      .putByLevel(
        process.env.VUE_APP_API_URL + '/v1', `patient/${id}`, options, (res: object) => {
        // commit(mutationType.UPDATE, res)
      })
  },
  async putPatientAssessment(
    { commit, dispatch, state }: ActionContext<PatientState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
      .putByLevel(
        process.env.VUE_APP_API_URL + '/v1', `patient/${id}/assessment`, options, (res: object) => {
        // commit(mutationType.UPDATE, res)
      })
  },
  async deletePatient(
    { commit, dispatch, state }: ActionContext<PatientState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
      .deleteByLevel(
        process.env.VUE_APP_API_URL + '/v1', `patient/${id}`, options, (res: object) => {
        // commit(mutationType.DELETE, res)
      })
  },
  async getPatientTypeList(
    { commit, dispatch, state }: ActionContext<PatientState, State>,
    options: object,
  ): Promise<void> {
    await HttpRequestServiceWithToken
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'patient-type', options, (res: PatientList) => {
        commit(mutationType.GET_TYPE_LISTS, res)
      })
  },
  async getPatientTypeById(
    { commit, dispatch, state }: ActionContext<PatientState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
    .getByLevel(process.env.VUE_APP_API_URL + '/v1', `patient-type/${id}`, options, (res: IPatientType) => {
      commit(mutationType.GET_TYPE_BY_ID, res)
    })
  },
}

export default actions
